import React, { createContext, useCallback, useMemo, useState } from "react";
import { VenueGroupConfig } from "../types/VenueGroup";
import { VenueUserConfig } from "../types/VenueUser";
import { withDerivedUserFullNames } from "../utils/userFullName";

type AppContextType = {
  venueGroupConfig: VenueGroupConfig | null;
  setVenueGroupConfig: React.Dispatch<VenueGroupConfig>;
  venueUserConfig: VenueUserConfig | null;
  setVenueUserConfig: React.Dispatch<VenueUserConfig>;
};

export const AppContext = createContext<AppContextType>({
  venueGroupConfig: null,
  setVenueGroupConfig: () => true,
  venueUserConfig: null,
  setVenueUserConfig: () => true
});

export const AppContextProvider = ({ children }: any) => {
  const [storedVenueGroupConfig, setStoredVenueGroupConfig] =
    useState<VenueGroupConfig | null>(null);
  const [venueUserConfig, setVenueUserConfig] =
    useState<VenueUserConfig | null>(null);

  const setVenueGroupConfig = useCallback(
    (config: VenueGroupConfig) =>
      setStoredVenueGroupConfig(withDerivedUserFullNames(config)),
    []
  );

  const contextValue = useMemo(
    () => ({
      venueGroupConfig: storedVenueGroupConfig,
      setVenueGroupConfig,
      venueUserConfig,
      setVenueUserConfig
    }),
    [storedVenueGroupConfig, setVenueGroupConfig, venueUserConfig]
  );

  return (
    <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>
  );
};
